const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/workItemUtils.ts';
import { WorkItem, WorkItemStatus } from '@cistec/common_web/defs/kisim';

/**
 * @return true if the given e-checkin form was finalized, i.e. it has been sent to the administration system and may
 *    no longer be modified; false otherwise.
 */
export function isECheckinFinalized(workItem: WorkItem) {
    // D = really finalized -> sent to ADMIN-SYSTEM
    // P = Patient did click Submit (=Abschliessen) but Patient Clearing (no PATNR) not done yet
    return workItem.STATUS === WorkItemStatus.done || workItem.STATUS === WorkItemStatus.preFinalized;
}

export function patientNeedsClearing(workItem: WorkItem) {
    // If an unlinked patient completes the online checkin,
    // then the work item is not set to DONE, but only RESULT=CHECKIN-FINALIZED is written.
    // For this case, the button should be displayed as after the check-in completion.
    // we want to force the patient to go to the hospital's counter
    return workItem.RESULT === 'CHECKIN-FINALIZED' && !isECheckinFinalized(workItem);
}
